<template>
  <div id="safe-manager">
    <div class="wrapper">
      <mainHeader class="mainHeader"></mainHeader>
      <img v-for="(value, index) in images" :key="index" v-bind:src="value" />
      <mainFooter class="mainFooter"></mainFooter>
      <bottomButton :show="true" id="bottomButton" title="在线申请" state="1"  @click="bottomClick"></bottomButton>
    </div>
    <!--  支付弹窗  -->
    <payView type="1" :show="payViewVisible" @payValue="payValue"></payView>
  </div>
</template>s
<script>

import mainHeader from '../view/header'
import mainFooter from '../view/footer'
import payView from '../components/pay'
import bottomButton from '../components/bottom-button4'

export default{
  data () {
    return {
      images: [
        require('../assets/icon-safe1.png'),
        require('../assets/icon-safe2.png'),
        require('../assets/icon-safe3.png'),
        require('../assets/icon-safe4.png'),
        require('../assets/icon-safe5.png'),
        require('../assets/icon-safe6.png'),
        require('../assets/icon-safe7.png')],
      payViewVisible: false
    }
  },
  methods: {
    bottomClick: function () {
      this.payViewVisible = true
    },
    payValue: function (state) {
      this.payViewVisible = false
      console.log('============支付回调')
    }
  },
  components: { // 注册组件
    mainHeader,
    mainFooter,
    payView,
    bottomButton
  }
}
</script>

<style scoped>
.wrapper{
  background-color: #F6F6F6;
  width: 100%;
  margin-bottom: 70px;
}
.mainHeader{
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
}
img{
  width: 100%;
  display: block;
}
img:first-of-type{
  margin-top: 55px;
}
.mainFooter{
}
.section{
  position: fixed;
  width: 100%;
  bottom: 0px;
  height: 65px;
  line-height: 65px;
  background-color: #FFFFFF;
  border-top: solid #EEEEEE 1px;
  box-sizing: border-box;
}
.section .apply{
  position: absolute;
  top: 10px;
  left: 15px;
  height: 45px;
  line-height: 45px;
  width: calc(100% - 30px );
  font-size: 16px;
  color: #FFFFFF;
  text-align: center;
  background-color: #C41335;
  border-radius: 4px;

}
</style>



// WEBPACK FOOTER //
// src/view/safe-manager.vue